import { pbxLocationsEn } from './en'

export const pbxLocationsEnGb = pbxLocationsEn
